/*
  Scroll motion matching the original cvjecara-mima.com site:
  - [data-scroll-reveal]          fade in and rise ("fade up") when scrolled into view
  - [data-scroll-reveal="fade"]   fade in without movement
  - [data-scroll-reveal-stagger]  reveal each child in turn (value = seconds between items)
  - [data-scroll-scale]           media inside scales out and back in as it crosses the viewport
  - [data-scroll-grow="0.6"]      element grows from 60% to full size as it scrolls up to the middle of the viewport (desktop)
  - [data-scroll-parallax="40"]   element drifts from +40px to -40px as it rises through the viewport (desktop)
*/
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  document.addEventListener('DOMContentLoaded', () => {
    const targets = document.querySelectorAll('[data-scroll-reveal], [data-scroll-reveal-stagger]');
    const scalers = Array.from(document.querySelectorAll('[data-scroll-scale]'));
    // Like the original's Elementor motion effects, grow and parallax only run on desktop.
    const desktop = window.matchMedia('(min-width: 992px)');
    const growers = Array.from(document.querySelectorAll('[data-scroll-grow]'));
    const drifters = Array.from(document.querySelectorAll('[data-scroll-parallax]'));
    if (!targets.length && !scalers.length && !growers.length && !drifters.length) return;

    document.documentElement.classList.add('js-scroll-reveal');

    document.querySelectorAll('[data-scroll-reveal-stagger]').forEach((list) => {
      const step = Number.parseFloat(list.dataset.scrollRevealStagger) || 0.1;
      Array.from(list.children).forEach((child, index) => {
        child.style.setProperty('--scroll-reveal-item-delay', `${(index * step).toFixed(2)}s`);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    // Anything already on the first screen animates in straight away, so a hero call to
    // action low on a phone screen is never left waiting for a scroll.
    const viewport = window.innerHeight;
    targets.forEach((target) => {
      if (target.getBoundingClientRect().top < viewport) {
        target.classList.add('is-revealed');
      } else {
        observer.observe(target);
      }
    });

    if (!scalers.length && !growers.length && !drifters.length) return;

    // The old site scaled images between 20% and 80% of the viewport: largest at the edges
    // of that range and at rest in the middle.
    const maxScale = 0.08;
    let frame = null;

    const update = () => {
      frame = null;
      const viewportHeight = window.innerHeight;
      scalers.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;
        const center = (rect.top + rect.height / 2) / viewportHeight;
        const progress = Math.min(Math.max((center - 0.2) / 0.6, 0), 1);
        const distance = Math.abs(progress - 0.5) * 2;
        element.style.setProperty('--scroll-scale', (1 + maxScale * distance).toFixed(4));
      });

      // Progress through the viewport: 0 as the element's top enters at the bottom,
      // 1 as its bottom leaves at the top. Each effect maps a slice of that range.
      // The nearest ancestor that is not itself moving is measured, so no
      // transform ever feeds back into the progress that drives it.
      const progressIn = (element, start, end) => {
        let reference = element.parentElement;
        while (reference.matches('[data-scroll-grow], [data-scroll-parallax]')) {
          reference = reference.parentElement;
        }
        const rect = reference.getBoundingClientRect();
        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        return Math.min(Math.max((progress - start) / (end - start), 0), 1);
      };

      growers.forEach((element) => {
        const from = Number.parseFloat(element.dataset.scrollGrow) || 0.6;
        const scale = desktop.matches ? from + (1 - from) * progressIn(element, 0.05, 0.5) : 1;
        element.style.transform = scale === 1 ? '' : `scale(${scale.toFixed(4)})`;
      });

      drifters.forEach((element) => {
        const distance = Number.parseFloat(element.dataset.scrollParallax) || 40;
        const offset = desktop.matches ? distance * (1 - 2 * progressIn(element, 0, 1)) : 0;
        element.style.transform = offset === 0 ? '' : `translateY(${offset.toFixed(1)}px)`;
      });
    };

    const requestUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  });
}
